import _ from 'lodash'

export default {
  VERMELHO_ESCURO: 'vermelho-escuro',
  VERMELHO_MEDIO: 'vermelho-medio',
  VERMELHO_CLARO: 'vermelho-claro',
  ROSA_ESCURO: 'rosa-escuro',
  ROSA_MEDIO: 'rosa-medio',
  ROSA_CLARO: 'rosa-claro',
  PURPURA_ESCURO: 'purpura-escuro',
  PURPURA_MEDIO: 'purpura-medio',
  PURPURA_CLARO: 'purpura-claro',
  VIOLETA_ESCURO: 'violeta-escuro',
  VIOLETA_MEDIO: 'violeta-medio',
  VIOLETA_CLARO: 'violeta-claro',
  AZUL_ESCURO: 'azul-escuro',
  AZUL_MEDIO: 'azul-medio',
  AZUL_CLARO: 'azul-claro',
  AZUL_GLAUCO_ESCURO: 'azul-glauco-escuro',
  AZUL_GLAUCO_MEDIO: 'azul-glauco-medio',
  AZUL_GLAUCO_CLARO: 'azul-glauco-claro',
  AZUL_COLUMBIA_ESCURO: 'azul-columbia-escuro',
  AZUL_COLUMBIA_MEDIO: 'azul-columbia-medio',
  AZUL_COLUMBIA_CLARO: 'azul-columbia-claro',
  VERDE_SKOBELOFF_ESCURO: 'verde-skobeloff-escuro',
  VERDE_SKOBELOFF_MEDIO: 'verde-skobeloff-medio',
  VERDE_SKOBELOFF_CLARO: 'verde-skobeloff-claro',
  VERDE_ESCURO: 'verde-escuro',
  VERDE_MEDIO: 'verde-medio',
  VERDE_CLARO: 'verde-claro',
  VERDE_LIMAO_ESCURO: 'verde-limao-escuro',
  VERDE_LIMAO_MEDIO: 'verde-limao-medio',
  VERDE_LIMAO_CLARO: 'verde-limao-claro',
  AMARELO_PERA_ESCURO: 'amarelo-pera-escuro',
  AMARELO_PERA_MEDIO: 'amarelo-pera-medio',
  AMARELO_PERA_CLARO: 'amarelo-pera-claro',
  AMARELO_BISTRE_ESCURO: 'amarelo-bistre-escuro',
  AMARELO_BISTRE_MEDIO: 'amarelo-bistre-medio',
  AMARELO_BISTRE_CLARO: 'amarelo-bistre-claro',
  AMARELO_ESCURO: 'amarelo-escuro',
  AMARELO_MEDIO: 'amarelo-medio',
  AMARELO_CLARO: 'amarelo-claro',
  LARANJA_ESCURO: 'laranja-escuro',
  LARANJA_MEDIO: 'laranja-medio',
  LARANJA_CLARO: 'laranja-claro',
  ABOBORA_ESCURO: 'abobora-escuro',
  ABOBORA_MEDIO: 'abobora-medio',
  ABOBORA_CLARO: 'abobora-claro',
  MARROM_ESCURO: 'marrom-escuro',
  MARROM_MEDIO: 'marrom-medio',
  MARROM_CLARO: 'marrom-claro',
  CINZA_ESCURO: 'cinza-escuro',
  CINZA_MEDIO: 'cinza-medio',
  CINZA_CLARO: 'cinza-claro',
  PRETO_ESCURO: 'preto-escuro',
  PRETO_MEDIO: 'preto-medio',
  BRANCO: 'branco',

  _sp360: [{
    nome: 'vermelho-escuro',
    cor: '#9e0000',
    primaria: true,
    tom: 'escuro',
  },
  {
    nome: 'vermelho-medio',
    cor: '#e54542',
    primaria: true,
    tom: 'medio',
  },
  {
    nome: 'vermelho-claro',
    cor: '#ff7676',
    primaria: true,
    tom: 'claro',
  },
  {
    nome: 'rosa-escuro',
    cor: '#941B56',
    primaria: false,
    tom: 'escuro',
  },
  {
    nome: 'rosa-medio',
    cor: '#CC4277',
    primaria: false,
    tom: 'medio',
  },
  {
    nome: 'rosa-claro',
    cor: '#DC8EAE',
    primaria: false,
    tom: 'claro',
  },
  {
    nome: 'purpura-escuro',
    cor: '#890F93',
    primaria: true,
    tom: 'escuro',
  },
  {
    nome: 'purpura-medio',
    cor: '#DD72E1',
    primaria: true,
    tom: 'medio',
  },
  {
    nome: 'purpura-claro',
    cor: '#F9A9FF',
    primaria: true,
    tom: 'claro',
  },
  {
    nome: 'violeta-escuro',
    cor: '#4A148B',
    primaria: false,
    tom: 'escuro',
  },
  {
    nome: 'violeta-medio',
    cor: '#7E57C1',
    primaria: false,
    tom: 'medio',
  },
  {
    nome: 'violeta-claro',
    cor: '#B29CDA',
    primaria: false,
    tom: 'claro',
  },
  {
    nome: 'azul-escuro',
    cor: '#01265b',
    primaria: true,
    tom: 'escuro',
  },
  {
    nome: 'azul-medio',
    cor: '#0041b9',
    primaria: true,
    tom: 'medio',
  },
  {
    nome: 'azul-claro',
    cor: '#4a94ff',
    primaria: true,
    tom: 'claro',
  },
  {
    nome: 'azul-glauco-escuro',
    cor: '#0A64BF',
    primaria: false,
    tom: 'escuro',
  },
  {
    nome: 'azul-glauco-medio',
    cor: '#4B85BF',
    primaria: false,
    tom: 'medio',
  },
  {
    nome: 'azul-glauco-claro',
    cor: '#80A4B7',
    primaria: false,
    tom: 'claro',
  },
  {
    nome: 'azul-columbia-escuro',
    cor: '#0e739b',
    primaria: true,
    tom: 'escuro',
  },
  {
    nome: 'azul-columbia-medio',
    cor: '#3fafe5',
    primaria: true,
    tom: 'medio',
  },
  {
    nome: 'azul-columbia-claro',
    cor: '#9fe4ff',
    primaria: true,
    tom: 'claro',
  },
  {
    nome: 'verde-skobeloff-escuro',
    cor: '#006064',
    primaria: false,
    tom: 'escuro',
  },
  {
    nome: 'verde-skobeloff-medio',
    cor: '#017B7D',
    primaria: false,
    tom: 'medio',
  },
  {
    nome: 'verde-skobeloff-claro',
    cor: '#539695',
    primaria: false,
    tom: 'claro',
  },
  {
    nome: 'verde-escuro',
    cor: '#1C5E21',
    primaria: false,
    tom: 'escuro',
  },
  {
    nome: 'verde-medio',
    cor: '#419F46',
    primaria: false,
    tom: 'medio',
  },
  {
    nome: 'verde-claro',
    cor: '#97D397',
    primaria: false,
    tom: 'claro',
  },
  {
    nome: 'verde-limao-escuro',
    cor: '#8BC32D',
    primaria: false,
    tom: 'escuro',
  },
  {
    nome: 'verde-limao-medio',
    cor: '#AED581',
    primaria: false,
    tom: 'medio',
  },
  {
    nome: 'verde-limao-claro',
    cor: '#AECCAE',
    primaria: false,
    tom: 'claro',
  },
  {
    nome: 'amarelo-pera-escuro',
    cor: '#C0CA33',
    primaria: false,
    tom: 'escuro',
  },
  {
    nome: 'amarelo-pera-medio',
    cor: '#C7CC69',
    primaria: false,
    tom: 'medio',
  },
  {
    nome: 'amarelo-pera-claro',
    cor: '#D8DB91',
    primaria: false,
    tom: 'claro',
  },
  {
    nome: 'amarelo-bistre-escuro',
    cor: '#827717',
    primaria: false,
    tom: 'escuro',
  },
  {
    nome: 'amarelo-bistre-medio',
    cor: '#AEB32A',
    primaria: false,
    tom: 'medio',
  },
  {
    nome: 'amarelo-bistre-claro',
    cor: '#D3E057',
    primaria: false,
    tom: 'claro',
  },
  {
    nome: 'amarelo-escuro',
    cor: '#f79e1c',
    primaria: true,
    tom: 'escuro',
  },
  {
    nome: 'amarelo-medio',
    cor: '#f8cd19',
    primaria: true,
    tom: 'medio',
  },
  {
    nome: 'amarelo-claro',
    cor: '#ffe578',
    primaria: true,
    tom: 'claro',
  },
  {
    nome: 'laranja-escuro',
    cor: '#FF7000',
    primaria: false,
    tom: 'escuro',
  },
  {
    nome: 'laranja-medio',
    cor: '#FF8E00',
    primaria: false,
    tom: 'medio',
  },
  {
    nome: 'laranja-claro',
    cor: '#F1B373',
    primaria: false,
    tom: 'claro',
  },
  {
    nome: 'abobora-escuro',
    cor: '#BE360C',
    primaria: false,
    tom: 'escuro',
  },
  {
    nome: 'abobora-medio',
    cor: '#FF5722',
    primaria: false,
    tom: 'medio',
  },
  {
    nome: 'abobora-claro',
    cor: '#F78065',
    primaria: false,
    tom: 'claro',
  },
  {
    nome: 'marrom-escuro',
    cor: '#3E2723',
    primaria: false,
    tom: 'escuro',
  },
  {
    nome: 'marrom-medio',
    cor: '#5E4037',
    primaria: false,
    tom: 'medio',
  },
  {
    nome: 'marrom-claro',
    cor: '#8C6E62',
    primaria: false,
    tom: 'claro',
  },
  {
    nome: 'cinza-escuro',
    cor: '#263237',
    primaria: false,
    tom: 'escuro',
  },
  {
    nome: 'cinza-medio',
    cor: '#455A64',
    primaria: false,
    tom: 'medio',
  },
  {
    nome: 'cinza-claro',
    cor: '#637A7A',
    primaria: false,
    tom: 'claro',
  },
  {
    nome: 'preto-escuro',
    cor: '#282828',
    primaria: false,
  },
  {
    nome: 'preto-medio',
    cor: '#333333',
    primaria: false,
  },
  {
    nome: 'branco',
    cor: '#FFFFFF',
    primaria: false,
  },
  ],

  //  Gradiente Para o GoogleMaps Weighted Location HeatMap
  getGradientVector () {
    return [
      'rgba(0, 255, 255, 0)',
      this.getCorPorNomeSp360(this.VERDE_SKOBELOFF_CLARO),
      this.getCorPorNomeSp360(this.VERDE_SKOBELOFF_MEDIO),
      this.getCorPorNomeSp360(this.VERDE_SKOBELOFF_ESCURO),
      this.getCorPorNomeSp360(this.AMARELO_CLARO),
      this.getCorPorNomeSp360(this.AMARELO_MEDIO),
      this.getCorPorNomeSp360(this.AMARELO_ESCURO),
      this.getCorPorNomeSp360(this.VERMELHO_CLARO),
      this.getCorPorNomeSp360(this.VERMELHO_MEDIO),
      this.getCorPorNomeSp360(this.VERMELHO_ESCURO),
    ]
  },

  getSimpleVector () {
    return [
      this.getCorPorNomeSp360(this.VERDE_SKOBELOFF_MEDIO),
      this.getCorPorNomeSp360(this.AMARELO_MEDIO),
      this.getCorPorNomeSp360(this.VERMELHO_MEDIO),
    ]
  },

  getGradientVectorRange () {
    let a = this.getGradientVector()
    a.shift()
    return [a.shift(), a.pop()]
  },

  _luminanace (r, g, b) {
    var a = [r, g, b].map(function (v) {
      v /= 255
      return v <= 0.03928
        ? v / 12.92
        : Math.pow((v + 0.055) / 1.055, 2.4)
    })
    return (a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722)
  },

  _contrast (rgb1, rgb2) {
    return (this._luminanace(rgb1.r, rgb1.g, rgb1.b) + 0.05) /
            (this._luminanace(rgb2.r, rgb2.g, rgb2.b) + 0.05)
  },

  hex2rgb (hex, opacity) {
    hex = (hex + '').trim()

    let rgb = null
    let match = hex.match(/^#?(([0-9a-zA-Z]{3}){1,3})$/)

    if (!match) {
      return null
    }

    rgb = {}

    hex = match[1]

    if (hex.length === 6) {
      rgb.r = parseInt(hex.substring(0, 2), 16)
      rgb.g = parseInt(hex.substring(2, 4), 16)
      rgb.b = parseInt(hex.substring(4, 6), 16)
    } else if (hex.length === 3) {
      rgb.r = parseInt(hex.substring(0, 1) + hex.substring(0, 1), 16)
      rgb.g = parseInt(hex.substring(1, 2) + hex.substring(1, 2), 16)
      rgb.b = parseInt(hex.substring(2, 3) + hex.substring(2, 3), 16)
    }

    rgb.css = 'rgb' + (opacity ? 'a' : '') + '('
    rgb.css += rgb.r + ',' + rgb.g + ',' + rgb.b
    rgb.css += (opacity ? ',' + opacity : '') + ')'

    return rgb
  },

  getCorPorNomeSp360 (nomeCor) {
    let results = this._sp360.filter((objCor) => {
      if (objCor.nome.toLowerCase() === nomeCor.toLowerCase()) {
        return true
      }
      return false
    })
    if (results.length > 0) {
      return results[0].cor
    } else {
      return ''
    }
  },

  getNomeDeCorSp360 (valorCor) {
    let results = this._sp360.filter((objCor) => {
      if (objCor.cor.toLowerCase() === valorCor.toLowerCase()) {
        return true
      }
      return false
    })
    if (results.length > 0) {
      return results[0].nome
    } else {
      return ''
    }
  },

  //  Retorna Todas as cores
  getVetorCoresSp360 () {
    return this._sp360.reduce((prev, el) => {
      prev.push(el.cor)
      return prev
    }, [])
  },

  // Retorna todas as cores Primarias da paleta de cores
  getVetorCoresPrimaria () {
    return this._sp360.reduce((prev, el) => {
      if (el.primaria) prev.push(el.cor)
      return prev
    }, [])
  },

  /**
     * Retorna Todas as cores por tom (luminosidade)
     * das cores da peleta geral
     * @param {String} Tom =  Claro, Medio, Escuro
     * @returns {Array}
     */
  getVetorCoresPorTom (tom) {
    if (tom) {
      return this._sp360.reduce((prev, el) => {
        if (el.tom === tom) prev.push(el.cor)
        return prev
      }, [])
    } else {
      return this._sp360.reduce((prev, el) => {
        if (el.tom) prev.push(el.cor)
        return prev
      }, [])
    }
  },

  /**
     * Retorna um vetor com as cores do farol na ordem verde/amarelo/vermelho
     */
  getVetorCoresFarol () {
    return [
      this.getCorPorNomeSp360(this.VERDE_MEDIO),
      this.getCorPorNomeSp360(this.AMARELO_MEDIO),
      this.getCorPorNomeSp360(this.VERMELHO_MEDIO),
    ]
  },

  getCoresMapa () {
    return {
      claro: '#f1f1fa',
      medio: '#9c9cd4',
      escuro: '#3b3b72',
    }
  },

  getVetorCoresPorContraste (contraste) {
    let hc = []
    this._sp360.forEach(corA => {
      _.forEachRight(this._sp360, corB => {
        let c = this._contrast(this.hex2rgb(corA.cor, 1), this.hex2rgb(corB.cor, 1))
        if (c >= contraste || 3) {
          hc.push(corB.cor)
        }
      })
    })
    hc = _.uniq(hc)
    return hc
  },

  /**
     * @cor String
     * A string da Cor em Hex
     * @alpha Number
     * Percentual de Transparencia desejada
     */
  setAlpha (cor, alpha) {
    try {
      if (!isNaN(alpha)) {
        return cor + alpha.toString(16)
      } else {
        throw (new Error('Erro Alpha não é um numero'))
      }
    } catch (error) {
      console.error(error)
    }
  },

  RGB2HSV (rgb) {
    var hsv = new Object()
    var max = this.max3(rgb.r, rgb.g, rgb.b)
    var dif = max - this.min3(rgb.r, rgb.g, rgb.b)
    hsv.saturation = (max == 0.0) ? 0 : (100 * dif / max)
    if (hsv.saturation == 0) hsv.hue = 0
    else if (rgb.r == max) hsv.hue = 60.0 * (rgb.g - rgb.b) / dif
    else if (rgb.g == max) hsv.hue = 120.0 + 60.0 * (rgb.b - rgb.r) / dif
    else if (rgb.b == max) hsv.hue = 240.0 + 60.0 * (rgb.r - rgb.g) / dif
    if (hsv.hue < 0.0) hsv.hue += 360.0
    hsv.value = Math.round(max * 100 / 255)
    hsv.hue = Math.round(hsv.hue)
    hsv.saturation = Math.round(hsv.saturation)
    return hsv
  },

  // RGB2HSV and HSV2RGB are based on Color Match Remix [http://color.twysted.net/]
  // which is based on or copied from ColorMatch 5K [http://colormatch.dk/]
  HSV2RGB (hsv) {
    var rgb = new Object()
    if (hsv.saturation == 0) {
      rgb.r = rgb.g = rgb.b = Math.round(hsv.value * 2.55)
    } else {
      hsv.hue /= 60
      hsv.saturation /= 100
      hsv.value /= 100
      var i = Math.floor(hsv.hue)
      var f = hsv.hue - i
      var p = hsv.value * (1 - hsv.saturation)
      var q = hsv.value * (1 - hsv.saturation * f)
      var t = hsv.value * (1 - hsv.saturation * (1 - f))
      switch (i) {
        case 0:
          rgb.r = hsv.value
          rgb.g = t
          rgb.b = p
          break
        case 1:
          rgb.r = q
          rgb.g = hsv.value
          rgb.b = p
          break
        case 2:
          rgb.r = p
          rgb.g = hsv.value
          rgb.b = t
          break
        case 3:
          rgb.r = p
          rgb.g = q
          rgb.b = hsv.value
          break
        case 4:
          rgb.r = t
          rgb.g = p
          rgb.b = hsv.value
          break
        default:
          rgb.r = hsv.value
          rgb.g = p
          rgb.b = q
      }
      rgb.r = Math.round(rgb.r * 255)
      rgb.g = Math.round(rgb.g * 255)
      rgb.b = Math.round(rgb.b * 255)
    }
    return rgb
  },

  // Adding HueShift via Jacob (see comments)
  HueShift (h, s) {
    h += s

    while (h >= 360.0) { h -= 360.0 }

    while (h < 0.0) { h += 360.0 }

    return h
  },

  // min max via Hairgami_Master (see comments)
  min3 (a, b, c) {
    return (a < b) ? ((a < c) ? a : c) : ((b < c) ? b : c)
  },

  max3 (a, b, c) {
    return (a > b) ? ((a > c) ? a : c) : ((b > c) ? b : c)
  },
}
